import { createFileRoute } from "@tanstack/react-router";
import { RequirePermission } from "@/currentUser/RequirePermission";
import { RepairersPage } from "@/repairers/RepairersPage";
import { parseRepairerSearch } from "@/repairers/repairersSearch";

export const Route = createFileRoute("/_authenticated/service-partners")({
  validateSearch: parseRepairerSearch,
  component: RepairersRoute,
});

function RepairersRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RequirePermission permission="admin_service_partner_read">
      <RepairersPage
        search={search}
        onSearchChange={(next, replace) =>
          void navigate({ search: next, replace })
        }
      />
    </RequirePermission>
  );
}
